<!--
 * @Author: liucheng liucheng@coocaa.com
 * @Date: 2023-05-10 14:30:24
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-07-18 09:56:29
 * @FilePath: \cms_main_site\src\views\page\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    class="parser-wrapper"
    ref="parser-wrapper"
    v-resize="handleParserResize"
  >
    <div
      :style="`transform: scale(${transformNum}); transform-origin: left top;width: ${originalPagesWidth}px;height: ${pagesSizeInfo.height}`"
    >
      <Parser
        ref="parserRef"
        v-if="formConf"
        :formConf="formConf"
        :domain="domain"
        class="parser"
      ></Parser>
      <NotFound v-if="notfound"></NotFound>
      <limit-page v-if="limit"></limit-page>
    </div>
  </div>
</template>

<script>
import { track } from '@cbee/bee-sdk-javascript'
import NotFound from '../NotFound.vue'
import LimitPage from '../LimitPage.vue'
import { Parser } from '@ccms/cms-engine'
import { getPageInfo } from '@/services/page'
import { upateDocumentMeta, getDevice } from '@/utils/common'
import debounce from 'lodash/debounce'
export default {
  components: {
    Parser,
    NotFound,
    LimitPage
  },
  data () {
    return {
      uniqueId: '',
      formConf: null,
      domain: '',
      notfound: false,
      limit: false,
      transformNum: 1,
      originalPagesWidth: 1920,
      pagesSizeInfo: {
        width: 'auto',
        height: 'auto'
      },
      resizeObserver: null,
      originalWidth: null
    }
  },
  methods: {
    scrollToContentByID (selectorId) {
      if (!selectorId) return
      const contentEl = document.querySelector(`#${selectorId}`)
      if (contentEl) {
        const contentTop = contentEl.getBoundingClientRect().top
        const headerHeight = document.querySelector('header')?.offsetHeight || 0
        window.scrollTo({
          top: contentTop - headerHeight
        })
      }
    },
    fetchData (uniqueId) {
      getPageInfo({ uniqueId }).then((data) => {
        document.title = `${data.title || '404'}-${process.env.VUE_APP_MAINTITLE}`
        upateDocumentMeta('keywords', data.metaKeyword || document.title)
        upateDocumentMeta('description', data.metaDescription || document.title)
        this.formConf = JSON.parse(data.config)
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToContentByID(this.$route.query.field)
            this.handleResize()
          }, 800)
        })
      }).catch(e => {
        this.formConf = null
        if (e.code === 8001) {
          this.limit = true
        } else {
          this.notfound = true
        }
      })
    },
    handleParserResize (e) {
      const clientWidth = document.documentElement.clientWidth
      if (e.height && this.originalWidth) {
        if (clientWidth !== this.originalWidth) {
          this.originalWidth = clientWidth
          this.cleanResize()
          this.handleResize()
        }
      } else {
        this.originalWidth = clientWidth
      }
    },
    cleanResize () {
      this.transformNum = 1
      this.pagesSizeInfo = {
        width: 'auto',
        height: 'auto'
      }
    },
    handleResize () {
      this.$nextTick(() => {
        const documentWidth = document.documentElement.clientWidth
        const deviceInfo = getDevice(documentWidth)
        const originalPagesWidth = deviceInfo.width || 1920
        this.originalPagesWidth = originalPagesWidth
        // if (deviceInfo.type === 'pc') {
        const transformNum = documentWidth / originalPagesWidth
        const pagesWapperRect = this.$refs['parser-wrapper'].getBoundingClientRect()
        console.log(pagesWapperRect.height, transformNum)
        this.pagesSizeInfo = {
          height: `${Math.round(pagesWapperRect.height * transformNum)}px`,
          width: `${originalPagesWidth}px`
        }
        this.transformNum = transformNum 
        // }
      })
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  created () {
    let uniqueId = ''
    if (this.$route.name === 'home') {
      uniqueId = this.$store.state.site.mainPageUniqueId
      // 神策埋点
      track('ViewHomePage')
    } else {
      uniqueId = this.$route.params.id
    }
    this.fetchData(uniqueId)
  }
}
</script>

<style lang="stylus" scoped>
.notfound
  display flex
  padding-top 100px
  justify-content center
  align-items center
  flex-direction column
/deep/.el-link
  display inline-block
  line-height 1
  white-space nowrap
  cursor pointer
  background #FFF
  border 1px solid #DCDFE6
  color #606266
  -webkit-appearance none
  text-align center
  box-sizing border-box
  outline 0
  margin 0
  transition 0.1s
  font-weight 500
  padding 9px 15px
  font-size 12px
  border-radius 3px
/deep/.el-link.is-underline:hover:after
  position absolute
  left 0
  right 0
  height 0
  bottom 0
  border-bottom none
.parser-wrapper
  // min-height: calc(100vh - 265px)
  // position relative
  // height 0
  display flex
  flex-direction column
  align-items flex-start
</style>
